import http from "./http-common";

const RESOURCENAME = 'overtime_types';

class DataService {
    getAll() {
        return http.get(`/${RESOURCENAME}`);
    }

    get(id) {
        return http.get(`/${RESOURCENAME}/${id}`);
    }

    create(data) {
        return http.post(`/${RESOURCENAME}`, data);
    }

    update(id, data) {
        return http.put(`/${RESOURCENAME}/${id}`, data);
    }

    delete(id) {
        return http.delete(`/${RESOURCENAME}/${id}`);
    }

    findBy(find, search) {
        return http.get(`/${RESOURCENAME}?${find}=${search}`);
    }
}

export default new DataService();